import PropTypes from 'prop-types';

import useRootOrganizationStore from '@/app/store/rootOrganization';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { nsSubscription } from '@/app/i18n/namespaces';

/**
 *
 * @param root0
 * @param root0.directProviderLegalName
 * @param root0.directProviderUuid
 */
function RenderSubscriptionDirectProvider({ directProviderLegalName, directProviderUuid }) {

    // Store
    const { uuid: rootOrganizationUuid } = useRootOrganizationStore(s => s.rootOrganization);

    return (
        <div className='text-center'>
            {directProviderLegalName ?
                <div className='text-ellipsis'>
                    {directProviderLegalName}
                </div>
                : null}
            {
                rootOrganizationUuid && directProviderUuid && rootOrganizationUuid === directProviderUuid ?
                    <small>
                        <Entity entity='text.is_direct' namespace={nsSubscription} />
                    </small>
                    : false
            }
        </div>
    );

}
RenderSubscriptionDirectProvider.propTypes = {
    directProviderLegalName: PropTypes.string,
    directProviderUuid: PropTypes.string
};
export default RenderSubscriptionDirectProvider;
